import WhatsApp from '@mui/icons-material/WhatsApp';
import { Fab } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import useWhatsappContact from '../../hooks/useWhatsappContact';

interface UseStylesProps {
  disableTextTransform: boolean;
}

const useStyles = makeStyles<UseStylesProps>()((theme, { disableTextTransform }) => ({
  fabButton: {
    position: 'fixed',
    right: theme.spacing(3),
    bottom: theme.spacing(2.5),
    textTransform: disableTextTransform ? 'none' : 'lowercase',
    height: theme.spacing(7),
    borderRadius: theme.spacing(7 / 2),
    zIndex: theme.zIndex.speedDial,
    [theme.breakpoints.only('xs')]: {
      height: 40,
    },
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));

interface ContactUsFloatButtonProps {
  brandName?: string;
  customerSupportPhone?: string | null;
  disableTextTransform?: boolean;
}

const ContactUsFloatButton = ({
  brandName,
  customerSupportPhone,
  disableTextTransform = false,
}: ContactUsFloatButtonProps) => {
  const { classes } = useStyles({ disableTextTransform });
  const { href, label } = useWhatsappContact({ brandName, customerSupportPhone });

  return (
    <a href={href} target="_blank" rel="noreferrer">
      <Fab variant="extended" color="primary" className={classes.fabButton}>
        <WhatsApp className={classes.icon} />
        {label}
      </Fab>
    </a>
  );
};

export default ContactUsFloatButton;
